import FilterForm from 'components/forms/FilterForm';
import { DatePicker, Empty, Form, FormProps, Input, Select } from 'antd';
import { Dayjs } from 'dayjs';
import { IGraduateDiscipline } from 'interfaces/graduate_disciplines';
import { IProfessor } from 'interfaces/professor';
import { SearchOutlined } from '@ant-design/icons';
import { useSelect } from '@refinedev/antd';

export interface IInteractiveClassFilterForm {
  id: string;
  title: string;
  professor_id: string;
  discipline_id: string;
  status: string;
  period: [Dayjs, Dayjs] | null;
}

interface UsersFilterFormProps {
  searchFormProps: FormProps<IInteractiveClassFilterForm>;
  enabled: boolean;
}

export const InteractiveClassListFilter = ({
  searchFormProps,
  enabled
}: UsersFilterFormProps) => {
  const { selectProps: professorSelectProps } = useSelect<IProfessor>({
    resource: 'professors',
    queryOptions: {
      enabled
    },
    optionLabel: 'name',
    optionValue: 'id',
    onSearch: value => [
      {
        field: 'filter[by_name]',
        operator: 'eq',
        value
      }
    ]
  });

  const { selectProps: disciplineSelectProps } = useSelect<IGraduateDiscipline>(
    {
      resource: 'graduate_disciplines',
      queryOptions: {
        enabled
      },
      optionLabel: 'name',
      optionValue: 'id',
      onSearch: value => [
        {
          field: 'filter[name]',
          operator: 'eq',
          value
        }
      ],
      pagination: {
        mode: 'server',
        pageSize: 100
      }
    }
  );
  return (
    <FilterForm searchFormProps={searchFormProps}>
      <Form.Item name="title">
        <Input placeholder="Título da aula" suffix={<SearchOutlined />} />
      </Form.Item>

      <Form.Item name="id">
        <Input placeholder="ID da reunião" />
      </Form.Item>

      <Form.Item name="professor_id">
        <Select {...professorSelectProps} placeholder="Selecione o professor" />
      </Form.Item>

      <Form.Item name="discipline_id">
        <Select
          {...disciplineSelectProps}
          placeholder="Selecione a disciplina"
          notFoundContent={
            <Empty description="Nenhuma disciplina encontrada. Tente refazer sua busca com outros termos" />
          }
        />
      </Form.Item>

      <Form.Item name="period">
        <DatePicker.RangePicker
          placeholder={['Data inicial', 'Data final']}
          format="DD/MM/YYYY"
        />
      </Form.Item>

      <Form.Item name="status">
        <Select defaultValue="" placeholder="Selecione o status">
          <Select.Option value="">Todos</Select.Option>
          <Select.Option value="created">Criada</Select.Option>
          <Select.Option value="started">Iniciada</Select.Option>
          <Select.Option value="cancelled">Cancelada</Select.Option>
          <Select.Option value="finished">Finalizada</Select.Option>
          <Select.Option value="suspended">Suspensa</Select.Option>
        </Select>
      </Form.Item>
    </FilterForm>
  );
};
